import React, { useEffect } from "react";
import "./BrandSection.css";
import AOS from "aos";
import "aos/dist/aos.css";
import ac1 from '../assets/ac1.jpg';
import ac2 from '../assets/ac2.jpg';
import ac3 from '../assets/ac3.jpg';
import ac4 from '../assets/ac4.jpg';

export default function BrandSection() {
    useEffect(() => {
        AOS.init({
            duration: 1200,
            once: false,
            easing: "ease-out",
        });
    }, []);

    const images = [ac1, ac2, ac3, ac4, ac1, ac2];

    return (
        <section className="brand-section">
            <div className="brand-img-row">
                {images.map((img, i) => (
                    <img
                        key={i}
                        src={img}
                        className="brand-img"
                        alt="brand"
                        data-aos="fade-up"       // <-- AOS animation type
                        data-aos-delay={i * 100} // <-- stagger effect
                        data-aos-once="false"
                    />
                ))}
            </div>
        </section>
    );
}
